import { render, staticRenderFns } from "./FormatReferenceDocumentKindFilter.vue?vue&type=template&id=d8f533d8&scoped=true&"
import script from "./FormatReferenceDocumentKindFilter.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceDocumentKindFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceDocumentKindFilter.vue?vue&type=style&index=0&id=d8f533d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f533d8",
  null
  
)

export default component.exports